import { render, staticRenderFns } from "./DialogMedias.vue?vue&type=template&id=32649638"
import script from "./DialogMedias.vue?vue&type=script&lang=js"
export * from "./DialogMedias.vue?vue&type=script&lang=js"
import style0 from "./DialogMedias.vue?vue&type=style&index=0&id=32649638&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports